var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "修改风资源名称",
        visible: _vm.visible,
        width: "20%",
        "before-close": _vm.handleCancel
      }
    },
    [
      _c(
        "span",
        [
          _c("el-input", {
            attrs: { placeholder: "请输入风资源名称" },
            model: {
              value: _vm.itemName,
              callback: function($$v) {
                _vm.itemName = $$v
              },
              expression: "itemName"
            }
          })
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handleCancel } }, [
            _vm._v("取 消")
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }